import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/api";

export default function Login({ setIsLoggedIn }) {
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = { UsrName: user, UsrPwd: password };
      const res = await api.AdmincheckLogin(payload);

      const status = res?.AdminCheckLoginjs?.Table?.[0]?.status;
      const message = res?.Message;

      if (status === "Success") {
        // ✅ Store login info in sessionStorage
        sessionStorage.setItem("isLoggedIn", "true");
        sessionStorage.setItem("username", user);
        sessionStorage.setItem("lastVisited", "/dashboard");

        setIsLoggedIn(true);
        navigate("/dashboard", { replace: true });
      } else {
        alert(message || "Invalid username or password");
      }
    } catch (err) {
      console.error(err);
      alert("Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center h-screen bg-gray-50">
      <form
        onSubmit={handleLogin}
        className="w-full max-w-sm p-8 bg-white shadow-xl rounded-xl"
      >
        <h1 className="mb-6 text-2xl font-bold text-center text-orange-600">
          Admin Login
        </h1>

        <input
          type="text"
          value={user}
          onChange={(e) => setUser(e.target.value)}
          placeholder="User Name"
          className="w-full p-3 mb-4 border rounded-md"
          required
        />

        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          className="w-full p-3 mb-6 border rounded-md"
          required
        />

        <button
          type="submit"
          disabled={loading}
          className="w-full py-3 font-semibold text-white bg-orange-500 rounded-lg hover:bg-orange-600"
        >
          {loading ? "Logging in..." : "Login"}
        </button>
      </form>
    </div>
  );
}



// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import api from "../api/api";

// export default function Login({ setIsLoggedIn }) {
//   const [user, setUser] = useState("");
//   const [password, setPassword] = useState("");
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       const payload = { UsrName: user, UsrPwd: password };
//       const res = await api.AdmincheckLogin(payload);

//       const status = res?.AdminCheckLoginjs?.Table?.[0]?.status;
//       const message = res?.Message;

//       if (status === "Success") {
//         // ✅ Save login info consistently
//         localStorage.setItem("isLoggedIn", "true");
//         localStorage.setItem("username", user);
//         setIsLoggedIn(true);

//         navigate("/dashboard", { replace: true });
//       } else {
//         alert(message || "Invalid username or password");
//       }
//     } catch (err) {
//       console.error(err);
//       alert("Login failed. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="flex items-center justify-center h-screen bg-gray-50">
//       <form
//         onSubmit={handleLogin}
//         className="w-full max-w-sm p-8 bg-white shadow-xl rounded-xl"
//       >
//         <h1 className="mb-6 text-2xl font-bold text-center text-orange-600">
//           Admin Login
//         </h1>

//         <input
//           type="text"
//           value={user}
//           onChange={(e) => setUser(e.target.value)}
//           placeholder="User Name"
//           className="w-full p-3 mb-4 border rounded-md"
//           required
//         />

//         <input
//           type="password"
//           value={password}
//           onChange={(e) => setPassword(e.target.value)}
//           placeholder="Password"
//           className="w-full p-3 mb-6 border rounded-md"
//           required
//         />

//         <button
//           type="submit"
//           disabled={loading}
//           className="w-full py-3 font-semibold text-white bg-orange-500 rounded-lg hover:bg-orange-600"
//         >
//           {loading ? "Logging in..." : "Login"}
//         </button>
//       </form>
//     </div>
//   );
// }

